<template>
	<div v-if="usuario.ID">
		<!-- <update></update> -->
		<nav>
			<topbar id="maintop" :nombre="nombreSeccion" @togglemenu="verMenu = !verMenu"></topbar>
		</nav>
		<aside id="mainside" :class="(verMenu) ? 'active' : ''" class="bg-light text-dark">
			<button class="btn btn-sm btn-warning hideMenu" @click="verMenu = !verMenu">
				<span class="fa fa-bars"></span>
			</button>
			<sidebar @verperfil="verPerfil = true" @fichar="fichar"></sidebar>
		</aside>
		<section id="mainmain" :style="estiloMain">
			<router-view class="text-left">Contenido</router-view>
		</section>
		<mi-perfil v-if="verPerfil" @cerrar="verPerfil = false"></mi-perfil>
		<fichar v-if="fichando" @cerrar="fichando = null"></fichar>
	</div>
</template>

<script>
import Update from '../update/update'
import Sidebar from './sidebar'
import MiPerfil from '../mi-perfil/mi-perfil'
import TopBar from '../topbar/topbar'
import Fichar from '../../../../gestion-jornada/vue/components/editor/fichar.vue'
import { mapGetters, mapMutations } from 'vuex'
export default {
	name: 'principal',
	components: {
		'topbar': TopBar,
		'sidebar': Sidebar,
		'mi-perfil': MiPerfil,
		'fichar': Fichar,
		Update
	},

	watch: {
		'usuario': function (newVal) {
			if (newVal === null) {
				this.ultimoAvisoFichar = null
				window.clearInterval(this.intervaloFichar)
			}
		}
	},
	created () {
		this.$router.beforeEach((to, from, next) => {
			const nombre = (to.name) ? to.name : ''
			this.setTitulo(nombre)
			this.verMenu = false
			next()
		})

		this.calculaDimensiones()

		this.setTitulo(this.$router.history.current.name)

		window.addEventListener('resize', () => {
			this.calculaDimensiones()
		})

		this.intervaloFichar = window.setInterval(() => {
			this.checkFichaje()
		}, 60000)
		this.checkFichaje()
	},
	data () {
		return {
			verMenu: false,
			verPerfil: false,
			nombreSeccion: '',
			estiloMain: {
				position: 'relative',
				display: 'block'
			},
			fichando: null,
			ultimoAvisoFichar: null,
			mostrandoAvisoFichar: false,
			intervaloFichar: null
		}
	},

	computed: {
		...mapGetters({
			'usuario': 'session/usuario'
		})
	},

	methods: {
		...mapMutations({
			setTitulo: 'top/setTitulo'
		}),
		checkFichaje () {
			if (!this.usuario || this.mostrandoAvisoFichar) {
				return
			}

			if (!this.ultimoAvisoFichar || (this.ultimoAvisoFichar && new Date().getTime() - this.ultimoAvisoFichar > 300000)) {
				this.$http.get('gestion-jornada/php/api/checkFichajePendiente.php')
					.then(res => {
						const datos = res.data
						if (datos.ignorar) {
							this.mostrandoAvisoFichar = false
							return
						}
						if (datos.trabajando && !datos.haFichado) {
							this.ultimoAvisoFichar = new Date().getTime()
							this.$store.commit('alertas/confirm', {
								titulo: '¿Fichar entrada?',
								mensaje: 'Parece ser que no has fichado la entrada.\n\n¿Quieres hacerlo ahora?',
								buttons: [
									{
										titulo: 'Fichar ahora',
										clase: 'btn btn-sm btn-success',
										icono: 'fa fa-address-card',
										valor: true
									},
									{
										titulo: 'Postponer 5 minutos',
										clase: 'btn btn-sm btn-warning',
										icono: 'fa fa-clock-o',
										valor: false
									}
								],
								callback: acepta => {
									if (acepta) {
										this.fichar()
									}
									this.mostrandoAvisoFichar = false
								}
							})
							this.mostrandoAvisoFichar = true
						} else if (!datos.trabajando && datos.haFichado) {
							this.ultimoAvisoFichar = new Date().getTime()
							this.$store.commit('alertas/confirm', {
								titulo: '¿Fichar salida?',
								mensaje: 'Parece ser que no has fichado la salida.\n\n¿Quieres hacerlo ahora?',
								buttons: [
									{
										titulo: 'Fichar ahora',
										clase: 'btn btn-sm btn-success',
										icono: 'fa fa-address-card',
										valor: true
									},
									{
										titulo: 'Postponer 5 minutos',
										clase: 'btn btn-sm btn-warning',
										icono: 'fa fa-clock-o',
										valor: false
									}
								],
								callback: acepta => {
									if (acepta) {
										this.fichar()
									}
									this.mostrandoAvisoFichar = false
								}
							})
							this.mostrandoAvisoFichar = true
						}
					})
					.catch(e => {
						console.error(e)
					})
			}
		},
		calculaDimensiones () {
			// Calculamos las dimensiones del scope
			const altoVentana = window.innerHeight
			const anchoVentana = window.innerWidth

			const altoMain = altoVentana - 60
			const anchoMain = (anchoVentana > 1500) ? anchoVentana - 200 : (anchoVentana > 1200) ? anchoVentana - 40 : anchoVentana

			if (anchoVentana < 1200) {
				this.estiloMain = {
					position: 'absolute',
					display: 'block',
					left: (anchoVentana - anchoMain) + 'px',
					right: 0,
					top: 50 + 'px',
					height: altoMain + 'px',
					'overflow-y': 'auto'
				}
			} else {
				this.estiloMain = {
					position: 'absolute',
					display: 'block',
					marginLeft: (anchoVentana - anchoMain) + 'px',
					top: 50 + 'px',
					left: 0,
					height: altoMain + 'px',
					'overflow-y': 'auto'
				}
			}
		},
		fichar () {
			this.fichando = true
		},
		logout () {
			this.$store.dispatch('session/logout')
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
header {
	display: block;
	position: fixed;
	top:0;
	left: 0;
	right: 0;
	height: 50px;
	box-shadow: 0 0 10px rgba(0,0,0,0.2);
	/* background-color: #F3F3F4; */
	/*background-color: #25476A;*/
	background-color: #363D4A;
}

#maintop {
	z-index: 10;
}

header.dev {
	background-color: darkred;
	color: white;
}

.hideMenu {
	display: none;
}

aside {
	position: fixed;
	display: block;
	left: 0;
	top: 0;
	width: 200px;
	padding-top: 50px;
	bottom: 0;
	border-right: 1px solid #e0e0e0;
	/* background-color: #e9ebec; */
	background-color: #3D4553;
	color: white;
	overflow-y: auto;
}

.tituloSeccion {
	position: relative;
	display: table-cell;
	font-size: 1.5em;
	/* color: #666666;*/
	color: white;
	text-align: left;
	vertical-align: middle;
	padding-left: 20px;
}

.iconoNotificaciones {
	position: relative;
	display: table-cell;
	width: 50px;
	height: 50px;
	vertical-align: middle;
	text-align: center;
	cursor: pointer;
	color: white;
}

.iconoNotificaciones:hover {
	background-color: #e4e4e4;
	color: black;
}

section {
	position: absolute;
	display: block;
	margin-left: 200px;
	padding-top: 20px;
	/* background-color: #f3f3f3; */
	background-color: #F5F7FA;
	top: 50px;
	left: 0;
	bottom: 0;
	right: 0;
	overflow-x: auto;
}

@media (max-width:1500px) {
	#mainside {
		z-index: 9;
	}
	aside {
		position: fixed;
		display: block;
		left: 0;
		top: 0;
		max-width: 90%;
		width: 300px;
		bottom: 0;
		left: 0px;
		transform: translateX(-260px);
		border-right: 1px solid #e0e0e0;
		/* transition: transform 200ms ease-in-out; */
		-webkit-transition: transform 300ms cubic-bezier(0.550, 0.055, 0.675, 0.190);
		-moz-transition: transform 300ms cubic-bezier(0.550, 0.055, 0.675, 0.190);
			-o-transition: transform 300ms cubic-bezier(0.550, 0.055, 0.675, 0.190);
				transition: transform 300ms cubic-bezier(0.550, 0.055, 0.675, 0.190); /* easeInCubic */

		-webkit-transition-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
		-moz-transition-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
			-o-transition-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
				transition-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190); /* easeInCubic */
	}

	aside:hover {
		transform: translateX(0);
		-webkit-transition: transform 300ms cubic-bezier(0.215, 0.610, 0.355, 1.000);
		-moz-transition: transform 300ms cubic-bezier(0.215, 0.610, 0.355, 1.000);
			-o-transition: transform 300ms cubic-bezier(0.215, 0.610, 0.355, 1.000);
				transition: transform 300ms cubic-bezier(0.215, 0.610, 0.355, 1.000); /* easeOutCubic */

		-webkit-transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
		-moz-transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
			-o-transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
				transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000); /* easeOutCubic */
	}

	section {
		padding-top: 20px;
		position: absolute;
		display: block;
		/* z-index: 8; */
		margin-left: 40px;
	}
}

@media (max-width:1200px) {
	#mainside {
		z-index: 9;
	}
	aside {
		position: fixed;
		display: block;
		left: 0;
		top: 0;
		max-width: 90%;
		width: 400px;
		bottom: 0;
		left: 0px;
		transform: translateX(-100%);
		border-right: 1px solid #e0e0e0;
		transition: transform 600ms ease-in-out;
		font-size: 1.3em;
	}

	aside.active {
		transform: translateX(0);
	}

	section {
		position: relative;
		display: block;
		padding-top: 70px;
		/* z-index: 8; */
		margin-left: 0;
	}
}

@media print {
	nav {
		display: none;
	}
	aside {
		display: none;
	}
	html {
		background-color: white;
	}
	body {
		background-color: white;
	}
	section {
		position: relative !important;
		display: block !important;
		left: initial !important;
		top: initial !important;
		right: initial !important;
		bottom: initial !important;
		margin: initial !important;
		background-color: white !important;
		margin-left: 0;
		padding-top: 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/main/main.vue